import { Navigate, createFileRoute } from "@tanstack/react-router";
import { useMeContext } from "#/contexts/MeContext";

export const Route = createFileRoute("/")({
  component: RootRedirect,
});

const DEFAULT_MARKET = "fr";

function RootRedirect() {
  const { meData } = useMeContext();
  const defaultTenant = meData.tenants[0];

  if (defaultTenant === undefined) return null;

  return (
    <Navigate
      to="/$tenantCode/$market"
      params={{ tenantCode: defaultTenant.code, market: DEFAULT_MARKET }}
      replace
    />
  );
}
